
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/[id]",
      function () {
        return require("private-next-pages/models/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models/[id]"])
      });
    }
  